import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    // [types.SET_WORK_TYPES]: (state, items) => Vue.set(state, 'items', items),
    [types.SET_WORK_TYPES]: (state, items) => state.items = items,
    [types.ADD_OR_UPDATE_WORK_TYPE]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_WORK_TYPE]: (state, item) => removeItem(state, item)
}